<template>
  <div v-if="
  this.enableAccessAuthCreate('O1', this.getUser.pref.select.cauth) === true">
    <div v-if="this.getUser.pref.select.fdid !== null && this.getUser.pref.select.fdid !== ''">
      <v-btn :color="ui.btnColor" flat dark @click="openDialog()"
      v-if="this.data.btnSize === 'flat'">
        <v-icon left>
          add
        </v-icon>
        {{data.btnTitle}}
      </v-btn>
      <v-btn :color="ui.bkgdColor" :class="ui.textSubheadingBold" icon dark @click="openDialog()"
      v-else-if="this.data.btnSize === 'iconAdd'">
        <v-icon>
          add
        </v-icon>
      </v-btn>
      <v-btn :color="ui.bkgdColor" :class="ui.textSubheadingBold" icon dark @click="openDialog()"
      v-else>
        <v-icon>
          notifications
        </v-icon>
      </v-btn>
    </div>
    <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogLarge">
      <v-card :color="ui.bkgdColor">
        <v-card-title :class="ui.textTitle">
          <v-layout row>
            <v-icon large left :color="ui.btnColor"> add </v-icon>
            <span :class="ui.textHeadline">
              <div :class="ui.textColor">
                New Notification
              </div>
            </span>
            <v-spacer/>
          </v-layout>
        </v-card-title>
        <v-progress-linear :color="ui.btnColor" height="1" value="100"/>
        <v-card-text :class="ui.bkgdColor">
          <v-layout class="text-xs-left ml-3 mr-2 mt-2">
            <div :class="ui.textSubheading">
              {{stepInfo.title}}
            </div>
          </v-layout>
          <v-layout class="text-xs-left ml-3 mr-2 mt-2">
            <div :class="ui.textSubheading">
              {{stepInfo.msg}}
            </div>
          </v-layout>
          <v-form v-model="valid" lazy-validation>
            <v-container :class="ui.bkgdColor" v-if="this.step == 0">
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs11>
                  <v-text-field
                  v-model="localForm.title"
                  :rules="mustBeLessThanSmall"
                  prepend-icon="notifications"
                  hint="operations notification title"
                  persistent-hint
                  required
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <div v-if="
              opsNotiAsset.id !== null &&
              opsNotiAsset.id !== undefined &&
              opsNotiAsset.id !== ''
              ">
                <v-layout class="text-xs-left ml-2 mr-2 mt-4">
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                    <v-avatar>
                    <v-icon :color="ui.colorWarning"> emoji_transportation </v-icon>
                    </v-avatar>
                    <div :class="ui.textWarning">
                      Asset
                    </div>
                  </v-chip>
                  <v-spacer/>
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                    <div :class="ui.textWarning">
                      <!-- {{displayDocumentIDGTypeA(this.data.detail.basic.tag, this.data.detail.basic.idg)}} -->
                    </div>
                  </v-chip>
                </v-layout>
                <v-layout row wrap class="ml-3 mr-2 mt-2">
                  <v-flex xs11>
                    <v-text-field
                    :label="opsNotiAsset.title"
                    prepend-icon="title"
                    hint="asset name"
                    persistent-hint
                    readonly
                    outline
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row wrap class="ml-3 mr-2">
                  <v-flex xs11>
                    <v-text-field
                    :label="opsNotiAsset.id"
                    prepend-icon="fingerprint"
                    hint="asset tag"
                    persistent-hint
                    readonly
                    outline
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout row :class="ui.textSubheading"
                v-if="this.getCurrentPage !== '/registerlist'">
                  <v-spacer/>
                  <Append :data="{tag: 'A1'}"/>
                </v-layout>
              </div>
            </v-container>
            <v-container :class="ui.bkgdColor" v-if="this.step == 1">
              <!-- <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs11>
                  <v-select
                    v-model="localForm.type"
                    :items="opsNotificationType"
                    color="wplblue0"
                    prepend-icon="notifications"
                    hint="notification type"
                    persistent-hint
                  >
                  </v-select>
                </v-flex>
              </v-layout> -->
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs11>
                  <v-select
                    v-model="localForm.org"
                    :items="opsNotificationOrigin"
                    color="wplblue0"
                    prepend-icon="adjust"
                    hint="notification source"
                    persistent-hint
                  >
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="ml-2 mr-2">
                <v-flex xs11>
                  <v-select
                    v-model="localForm.dis"
                    :items="engineeringDiscipline"
                    color="wplblue0"
                    prepend-icon="engineering"
                    hint="technical discipline"
                    persistent-hint
                  >
                  </v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="ml-2 mr-2 mt-4">
                <v-flex xs10 offset-xs1>
                  <v-textarea
                  :color="ui.textColor"
                  :background-color="ui.btnColor"
                  v-model="localForm.des"
                  label="Operations Observation"
                  :disabled="false"
                  :outline="true"
                  :rules="ruleMustBeNotUndefinedANDLessThan2000"
                  hint="reported event, or noted experience"
                  auto-grow
                  persistent-hint
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>

            <v-container :class="ui.bkgdColor" v-if="this.step == 2">
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> place </v-icon>
                  </v-avatar>
                  Facility
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{getUser.pref.select.fname}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> place </v-icon>
                  </v-avatar>
                  {{getUser.pref.select.fname}}
                </v-chip>
              </v-layout>
              <div v-if="
                opsNotiAsset.id !== null &&
                opsNotiAsset.id !== undefined &&
                opsNotiAsset.id !== ''
              ">
                <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                    <v-avatar>
                    <v-icon> emoji_transportation </v-icon>
                    </v-avatar>
                    Asset Name
                  </v-chip>
                  <v-spacer/>
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                    {{opsNotiAsset.title}}
                  </v-chip>
                </v-layout>
                <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                    <v-avatar>
                    <v-icon> emoji_transportation </v-icon>
                    </v-avatar>
                    {{opsNotiAsset.title}}
                  </v-chip>
                </v-layout>
                <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                    <v-avatar>
                    <v-icon> fingerprint </v-icon>
                    </v-avatar>
                    Asset Tag
                  </v-chip>
                  <v-spacer/>
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                    {{opsNotiAsset.id}}
                  </v-chip>
                </v-layout>
                <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                  <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                    <v-avatar>
                    <v-icon> fingerprint </v-icon>
                    </v-avatar>
                    {{opsNotiAsset.id}}
                  </v-chip>
                </v-layout>
              </div>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> notifications </v-icon>
                  </v-avatar>
                  Notification
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.title}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> notifications </v-icon>
                  </v-avatar>
                  {{localForm.title}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> grid_view </v-icon>
                  </v-avatar>
                  Type
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.type}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> grid_view </v-icon>
                  </v-avatar>
                  {{localForm.type}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> adjust </v-icon>
                  </v-avatar>
                  Origin
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.org}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> adjust </v-icon>
                  </v-avatar>
                  {{localForm.org}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-xs-only">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> engineering </v-icon>
                  </v-avatar>
                  Technical
                </v-chip>
                <v-spacer/>
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  {{localForm.dis}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2 hidden-sm-and-up">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> engineering </v-icon>
                  </v-avatar>
                  {{localForm.dis}}
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-2 mr-2">
                <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
                  <v-avatar>
                  <v-icon> short_text </v-icon>
                  </v-avatar>
                  Operations Notification
                </v-chip>
              </v-layout>
              <v-layout class="text-xs-left ml-4 mr-2 mt-2">
                <div :class="ui.textSubheading">
                  {{localForm.des}}
                </div>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
          @click="dialog = false" :color="ui.btnColor" flat>
            <v-icon left> exit_to_app </v-icon>
            Close
          </v-btn>
          <v-btn :disabled="!this.step > 0"
          class="hidden-xs-only"
          @click="previousStep(step)" :color="ui.btnColor" flat>
            <v-icon left> navigate_before </v-icon>
            Back
          </v-btn>
          <v-btn :disabled="!this.step > 0"
          class="hidden-sm-and-up"
          @click="previousStep(step)" :color="ui.btnColor" flat>
            <v-icon> navigate_before </v-icon>
          </v-btn>
          <v-spacer/>
          <v-btn :disabled="!valid" v-if="this.step < 4 && this.enableNextBtn"
          @click="nextStep(step)" :color="ui.btnColor" flat
          class="hidden-xs-only">
            Next
            <v-icon right> navigate_next </v-icon>
          </v-btn>
          <v-btn :disabled="!valid" v-if="this.step < 4 && this.enableNextBtn"
          @click="nextStep(step)" :color="ui.btnColor" flat
          class="hidden-sm-and-up"
          >
            <v-icon> navigate_next </v-icon>
          </v-btn>
          <v-btn :disabled="!valid"
          v-if="enableSubmit"
          class="hidden-xs-only"
          @click="createNotification()" :color="ui.colorWarning" flat>
            <v-icon left> add </v-icon>
            Submit
          </v-btn>
          <v-btn :disabled="!valid"
          v-if="enableSubmit"
          class="hidden-sm-and-up"
          @click="createNotification()" :color="ui.colorWarning" flat>
            <v-icon> add </v-icon>
          </v-btn>
          <BtnSpin :btnSpec="btnInfo1" v-if="btnSpinChangeDetail === true"/>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import BtnSpin from "@/frame/animation/components/BtnSpin";
import storeFunctions from "@/data/functions/mixins/storeFunctions.js";
import ruleTextfield from "@/data/rules/mixins/rulesTextfield.js";
import docRevsModFunctions from "@/document/revisions/mixins/docRevsModFunctions.js";
import changeDetail from "@/support/detail/mixins/changeDetail.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import createFirebase from "@/data/cloud/firebase/mixins/createFirebase.js";
import adminFunctions from "@/admin/functions/mixins/adminFunctions.js";
import generateForms from "@/data/functions/mixins/generateForms.js";
import generateID from "@/data/cloud/firebase/mixins/generateID.js";
import relationshipsFunctions from "@/data/functions/mixins/relationshipsFunctions.js";
import opsOptions from "@/data/options/mixins/opsOptions.js";
import moment from "moment";
import getData from "@/data/cloud/firebase/mixins/getData.js";
import transFunctions from "@/support/transitions/mixins/transFunctions.js";
import techOptions from "@/data/options/mixins/techOptions.js";
import Append from "@/data/append/components/Append";
// import Append from "@/data/append/components/Append";
import { mapGetters } from "vuex";

export default {
  components: {
    BtnSpin,
    Append
  },
  // eslint-disable-next-line
  mixins: [
    getData,
    apptheme,
    adminFunctions,
    docRevsModFunctions,
    createFirebase,
    ruleTextfield,
    opsOptions,
    storeFunctions,
    changeDetail,
    relationshipsFunctions,
    generateID,
    generateForms,
    transFunctions,
    techOptions
  ],
  props: {
    data: {
      type: Object
    }
  },
  data() {
    return {
      dialog: false,
      btnSpinChangeDetail: false,
      valid: true,
      btnInfo1: {
        color: "red",
        icon: "person",
        name: "add user"
      },
      indeterminateProgressBar: false,
      step: 0,
      localForm: {
        title: "",
        id: "",
        des: "",
        type: "C1",
        assetTitle: "",
        assetId: "",
        adid: "",
        aid: "",
        aidg: "",
        at: "",
        atag: "",
        dis: "General",
        org: "Routine"
      },
      info: [
        {
          step: 0,
          title: "Operations Notification",
          // eslint-disable-next-line
          msg: "Create operations notificaton, observation or comment to confirm operation or note an abnormal event or report safety hazard.",
          icon: ""
        },
        {
          step: 1,
          title: "Ops Notification Type",
          // eslint-disable-next-line
          msg: "Notification type enables prioritisation of response.",
          icon: ""
        },
        {
          step: 2,
          title: "Verify and Submit",
          // eslint-disable-next-line
          msg: "Facility management or system / area coordinator will verify and acknowledge raised operational notification and the team will contact you if further action or info is required.",
          error: "",
          icon: ""
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["getUser", "getCurrentPage", "getDetailBasic"]),
    ui() {
      return this.uiTheme1;
    },
    stepInfo() {
      return this.info[this.step];
    },
    enableSubmit() {
      let logic = false;
      if (this.step === 2 && this.btnSpinChangeDetail === false) {
        logic = true;
      } else if (this.btnSpinChangeDetail === true) {
        logic = false;
      } else {
        logic = false;
      }
      return logic;
    },
    enableNextBtn() {
      let logic = false;
      if (this.step == 0 && this.localForm.title !== "") {
        logic = true;
      } else if (
        this.step == 1 &&
        this.localForm.type !== "" &&
        this.localForm.dis !== "" &&
        this.localForm.org !== "" &&
        this.localForm.des !== ""
      ) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    },
    opsNotiAsset() {
      let obj = {
        title: "",
        id: ""
      };
      if (this.data.info !== undefined && this.data.info !== null) {
        obj.title = this.data.info.basic.title;
        obj.id = this.data.info.basic.id;
      } else if (
        this.getDetailBasic !== null &&
        this.getDetailBasic.tag === "A1"
      ) {
        obj.title = this.getDetailBasic.title;
        obj.id = this.getDetailBasic.id;
      } else if (this.getDetailLink !== null && this.getDetailLink !== null) {
        if (this.getDetailLink.at !== "") {
          obj.title = this.getDetailLink.at;
          obj.id = this.getDetailLink.aid;
        }
      } else {
        if (this.getDetailBasic !== null && this.getDetailBasic !== undefined) {
          if (this.getDetailBasic.tag === "A1") {
            obj.title = this.getDetailBasic.title;
            obj.id = this.getDetailBasic.id;
          }
        }
      }
      return obj;
    }
  },
  methods: {
    nextStep(step) {
      this.step = step + 1;
    },
    previousStep(step) {
      this.step = step - 1;
    },
    openDialog() {
      this.dialog = true;
      this.step = 0;
      this.btnSpinReadResult = false;
      // ASSET
      if (
        this.data.info !== undefined &&
        this.data.info !== undefined &&
        this.data.info.basic.tag === "A1"
      ) {
        this.localForm.adid = this.data.info.basic.did;
        this.localForm.aid = this.data.info.basic.id;
        this.localForm.aidg = this.data.info.basic.idg;
        this.localForm.at = this.data.info.basic.title;
        this.localForm.atag = this.data.info.basic.tag;
      } else if (
        this.getDetailBasic !== null &&
        this.getDetailBasic !== undefined
      ) {
        if (this.getDetailBasic.tag === "A1") {
          this.localForm.adid = this.getDetailBasic.did;
          this.localForm.aid = this.getDetailBasic.id;
          this.localForm.aidg = this.getDetailBasic.idg;
          this.localForm.at = this.getDetailBasic.title;
          this.localForm.atag = this.getDetailBasic.tag;
        }
      } else {
        this.localForm.adid = "";
        this.localForm.aid = "";
        this.localForm.aidg = "";
        this.localForm.at = "";
        this.localForm.atag = "";
      }
    },
    closeDialog() {
      this.btnSpinReadResult = false;
    },
    createNotification() {
      this.btnSpinChangeDetail = true;
      // SET data source
      const tag = "O1";
      const did = this.generateDID("DATE", tag);
      const idg = this.generateIDG("date-gid");

      // GENERATE form
      let temp = this.generateNotificationForm(); // form is from compnew component

      // ASSIGN data
      temp.basic.did = did;
      temp.basic.idg = idg;
      temp.basic.tag = tag;
      temp.basic.act = true; // set to true

      // BASIC Data
      temp.basic.title = this.localForm.title;
      temp.basic.id = this.localForm.id;

      // CHAR Data
      temp.char.des = this.localForm.des;
      temp.char.dis = this.localForm.dis;
      temp.char.type = this.localForm.type;
      temp.char.org = this.localForm.org;

      // LINK DATA
      temp.link.adid = this.localForm.adid;
      temp.link.aid = this.localForm.aid;
      temp.link.aidg = this.localForm.aidg;
      temp.link.at = this.localForm.at;
      temp.link.atag = this.localForm.atag;

      // STATS
      temp.stats.dcrt = moment().format();

      // REV.
      temp.rev = this.generateInitialDocumentRev(tag);

      // CREATE OPS
      this.createFirebaseDocumentOnly(temp);

      // HELP
      console.log("NEW OPS NOTI");
      console.log(temp);
    }
  }
};
</script>
